var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockedButtons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 32,
    viewBox: "0 0 208 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 32,
    rx: 8,
    fill: "#838D90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.167 14.3333V12.6667C108.167 10.3655 106.301 8.5 104 8.5C101.699 8.5 99.8333 10.3655 99.8333 12.6667V14.3333M104 18.0833V19.75M101.333 23.5H106.667C108.067 23.5 108.767 23.5 109.302 23.2275C109.772 22.9878 110.154 22.6054 110.394 22.135C110.667 21.6002 110.667 20.9001 110.667 19.5V18.3333C110.667 16.9332 110.667 16.2331 110.394 15.6984C110.154 15.228 109.772 14.8455 109.302 14.6058C108.767 14.3333 108.067 14.3333 106.667 14.3333H101.333C99.9331 14.3333 99.2331 14.3333 98.6983 14.6058C98.2279 14.8455 97.8454 15.228 97.6057 15.6984C97.3333 16.2331 97.3333 16.9332 97.3333 18.3333V19.5C97.3333 20.9001 97.3333 21.6002 97.6057 22.135C97.8454 22.6054 98.2279 22.9878 98.6983 23.2275C99.2331 23.5 99.9331 23.5 101.333 23.5Z",
    stroke: "#FEFDFB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedButtons);
export default __webpack_public_path__ + "static/media/LockedButtons.15efbafbd61e80e79abcfff93925d295.svg";
export { ForwardRef as ReactComponent };